module.exports = __webpack_public_path__ + "static/media/townhouse_orange.c20ff36d.svg";